import React from "react";
import { Pagination as AntPagination, Select } from "antd";
import { useMediaQuery } from "react-responsive";

const Pagination = ({
  totalPages,
  currentPage,
  onPageChange,
  onPageSizeChange,
  searchPerformed
}) => {
  const isMobile = useMediaQuery({ maxWidth: 1050 });
  const pageSizeOptions = ["100", "500", "3000", "5000"];

  const handlePageSizeChange = (value) => {
    onPageSizeChange(Number(value));
  };

  return (
    <div
      // style={{
      //   display: "flex",
      //   justifyContent: isMobile ? "flex-end" : "space-between",
      //   alignItems: "center",
      // }}
      className="my-2 flex justify-end"
      style={{
        display: "flex",
        // justifyContent: isMobile && !searchPerformed ? "flex-end" : "space-between",
        alignItems: "center",
      }}
    >
      {!isMobile && !searchPerformed && (
        <div>
          <Select defaultValue="100" onChange={handlePageSizeChange}>
            {pageSizeOptions.map((size) => (
              <Select.Option key={size} value={size}>
                {size} Pages
              </Select.Option>
            ))}
          </Select>
        </div>
      )}
      <div>
        <AntPagination
          current={currentPage}
          total={totalPages * 10}
          onChange={onPageChange}
          showSizeChanger={false}
        />
      </div>
    </div>
  );
};

export default Pagination;
